import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-brand-dark py-24 px-4 border-t border-brand-border relative overflow-hidden" data-id="element-128">
      {/* Gradient band effect */}
      <div className="absolute inset-0 bg-gradient-to-b from-brand-accent/5 via-brand-accent/10 to-brand-accent/5 pointer-events-none" data-id="element-129"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex justify-center mb-8" data-id="element-131">
          <div className="bg-brand-accent/10 border border-brand-accent/20 p-5 rounded-full" data-id="element-132">
            <ShieldCheck size={48} className="text-brand-accent" data-id="element-133" />
          </div>
        </motion.div>

        <motion.h2 className="text-3xl md:text-4xl font-heading font-bold mb-8 text-white" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.15
      }} data-id="element-134">
          GARANTÍA <span className="text-brand-accent" data-id="element-135">PROFEPACK</span> — 7 DÍAS
        </motion.h2>

        <motion.div className="text-lg md:text-xl space-y-6 max-w-2xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.25
      }} data-id="element-136">
          <p className="text-white/70 bg-brand-card p-5 rounded-2xl border border-brand-border" data-id="element-137">
            Abrís los 12 volúmenes. Revisás los 6 bonos. Los usás en el aula si
            querés.
          </p>

          <p className="font-bold text-2xl text-white mt-8" data-id="element-138">
            Si en 7 días no es lo que esperabas:
          </p>

          <div className="py-4" data-id="element-139">
            <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} className="text-3xl md:text-4xl font-heading font-black text-brand-dark bg-brand-accent inline-block px-8 py-3 rounded-xl shadow-[0_0_30px_rgba(0,255,133,0.2)] transform -rotate-1 cursor-pointer hover:scale-105 hover:shadow-[0_0_40px_rgba(0,255,133,0.4)] transition-all" data-id="element-140">
              Te devolvemos el 100%.
            </button>
          </div>

          <p className="font-bold text-xl text-white/80" data-id="element-141">
            Sin preguntas. Sin formularios. Sin drama.
          </p>

          <p className="text-white/50 italic" data-id="element-142">
            La confianza que tenemos en el MegaPack nos permite ofrecerte eso.
          </p>
        </motion.div>
      </div>
    </section>;
}